export default __webpack_public_path__ + "static/media/info.9a78a09c.svg";